/* @flow */
import React from 'react';
// $FlowIgnore
import { MdKeyboardArrowRight } from 'react-icons/md';

export default function ArrowDownIcon({
  style
}: Object): React.Element {
  return <MdKeyboardArrowRight style={style} />;
}
